import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Loading } from "../../ui";
import { LibraryService } from "../library/LibraryService";
import { Library } from "./Library";

interface IProps {
	handleChange: (selectedLibraries: any[], actionType: any) => any;
	value?: any;
	defaultValue?: any;
	libraries?: Library[];
}

export const LibrarySelect = (props: IProps): ReactElement => {
	const [libraries, setLibraries] = useState<Library[]>();

	const libraryService = new LibraryService();

	useMemo(() => {
		if (!props.libraries) {
			const fetchLibraries = async () => {
				const libraryData = await libraryService.findAll();
				setLibraries(libraryData);
			};

			fetchLibraries();
		} else {
			setLibraries(props.libraries);
		}
	}, []);

	if (!libraries) {
		return <Loading />;
	}

	const options = libraries.map((library: Library) => {
		return {
			value: library.id,
			label: library.name,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			isMulti={true}
			isClearable={false}
			onChange={(selectedLibraries: any, actionType: any) => {
				if (!selectedLibraries) {
					selectedLibraries = [];
				}

				const keys = selectedLibraries.map((selectedItem: any) => {
					return selectedItem.value;
				});

				const libs = _.filter(libraries, library => {
					return _.indexOf(keys, library.id) !== -1;
				});

				props.handleChange(libs, actionType);
			}}
		/>
	);
};
